<template>
  <div>

    <EnrollmentsListFilters />

    <BCard no-body class="mb-0">
      <!-- Filters -->
      <div class="m-2">
        <BRow>
          <!-- Per Page -->
          <BCol cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <VueSelect v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{$t('entries')}}</label>
          </BCol>

          <!-- Search -->
          <BCol cols="12" md="6">
            <div class="d-flex align-items-center justify-content-between">
              <!-- <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'"  /> -->
              <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
              <BButton variant="primary" :to="{ name: 'enrollments-add' }" v-if="ability.can('create', 'enrollment')">
                <span class="text-nowrap">{{$t('Add Enrollment')}}</span>
              </BButton>
            </div>
          </BCol>
        </BRow>
      </div>

      <!-- Table -->
      <BTable  ref="refEnrollmentListTable" class="position-relative" :items="fetchEnrollments" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc">

        <template #cell(code)="data">
            <BLink :to="{ name: 'enrollments-view', params: { id: data.item.id } }" class="font-weight-bold d-block text-nowrap" > {{ data.item.code }} </BLink>
            <small v-if="groupOptions && groupOptions.length>1" class="text-muted">{{ !data.item.course.group_id ? 'Curso global -' : '' }} {{ (data.item.group_id ? data.item.group.name : data.item.course.group.name).toUpperCase() }}</small>
        </template>
        <template #cell(student)="data" >
          <BLink v-if="data.item.student" :to="{ name: 'students-view', params: { id: data.item.student.id } }" class="font-weight-bold d-block text-nowrap">{{ data.item.student.full_name }}</BLink>
          <span v-if="data.item.student">
            <small class="text-muted">{{ data.item.student.dni }}</small>
          </span>
        </template>

        <template #cell(course)="data" >
          <BLink v-if="data.item.course" :to="{ name: 'courses-view', params: { id: data.item.course.id } }" class="font-weight-bold d-block text-nowrap"><b>{{ data.item.course.name }}</b></BLink>
          <span>
            <small class="text-muted">{{ data.item.course.code}}</small>
          </span>
        </template>

        <!-- Celda: Duración -->
        <template #cell(duration)="data">
            <small>
                <span><b>Desde: </b>{{ format(new Date (data.item.start_date), 'dd-MM-yyyy') }}</span><br>
                <span><b>Hasta: </b>{{ data.item.end_date ? format(new Date (data.item.end_date), 'dd-MM-yyyy') : '(No definida)' }}</span>
            </small>
        </template>

        <!-- Celda: Renovación -->
        <template #cell(expiration_date)="data">
            {{ data.item.expiration_date ? format(new Date(data.item.expiration_date), 'dd-MM-yyyy') : '-' }}
        </template>

        <!-- Celda; Estado -->
        <template #cell(status)="data">
            <BBadge v-if="data.item.status" variant="light-success">Activa</BBadge>
            <BBadge v-else variant="light-secondary">Inactiva</BBadge>
        </template>

        <template #cell(actions)="data">
          <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>

            <BDropdownItem  @click="openRenewalModal(data.item.id)" v-if="ability.can('write', 'enrollment')">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Renovar mensualidad</span>
            </BDropdownItem>

            <BDropdownItem :to="{ name: 'enrollments-view', params: { id: data.item.id } }" v-if="ability.can('read', 'enrollment')">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">{{$t('Details')}}</span>
            </BDropdownItem>

            <BDropdownItem :to="{ name: 'enrollments-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'enrollment')">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{$t('Edit')}}</span>
            </BDropdownItem>

            <BDropdownItem @click="deletePopup(data.item.id, 'enrollments/deleteEnrollment', '', data.item.code)" v-if="ability.can('delete', 'enrollment')">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{$t('Delete')}}</span>
            </BDropdownItem>
          </BDropdown>
        </template>
      </BTable>

      <!-- Paginate -->
      <div class="mx-2 mb-2">
        <BRow>
          <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
          </BCol>
          <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <BPagination v-model="currentPage" :total-rows="totalEnrollments" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </BPagination>
          </BCol>
        </BRow>
      </div>

    </BCard>

    <BModal hide-footer ref="renewalModal" cancel-variant="outline-secondary" centered title="Renovar mensualidad" no-close-on-backdrop>
            <BForm @submit.prevent="">

                <BCol>
                  <BFormGroup label="Número de meses/plazos para renovar" label-for="months_number" >
                    <BFormInput type="number" step="0.01" id="months_number" required  v-model="renewParams.month_number"/>
                  </BFormGroup>
                </BCol>

                <BCol class="mb-1">
                  <label for="payment_method">Método de pago</label>
                  <VueSelect :key="renewParams.payment_method_id"  id="payment_method" v-model="renewParams.payment_method_id" :options="paymentMethods" label="name" :reduce="pay => pay.id" required v-if="paymentMethods" />
                </BCol>

                <BCol>
                  <BFormGroup class="mb-1" stacked  >
                      <BFormCheckbox v-model="renewParams.paid"> Pagada </BFormCheckbox>
                  </BFormGroup>
                </BCol>

                <BCol v-show="cashes && showCashes">
                  <label >Caja</label>
                    <VueSelect :key="renewParams.cash_id" v-model="renewParams.cash_id" :reduce="cash => cash.id" :options="cashes" label="name" id="payment-method" class="payment-selector" :clearable="false" :required="showCashes" />
                  </BCol>
               
                <BCol class="d-flex justify-content-end mt-2">
                    <BButton variant="danger" class="mr-1" @click="renewalModal.hide()">Cancelar</BButton>
                    <BButton id="submitbutton" variant="primary" type="submit" @click="renewMonthlyPayment" >Añadir</BButton>
                </BCol>
            </BForm>
      </BModal>
  </div>
</template>

<script>
import {   BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, BFormGroup, BForm, BFormCheckbox} from 'bootstrap-vue'
import { onUnmounted, provide, ref, watch} from '@vue/composition-api';
import EnrollmentsListFilters from './EnrollmentsListFilters.vue'
import enrollmentsStoreModule from '../enrollmentsStoreModule'
import useEnrollmentsList from './useEnrollmentsList'
import ability from '@/libs/acl/ability';
import popups from '@/hooks/popups'
import store from '@/store'
import { format } from 'date-fns';
import { VueSelect } from 'vue-select'
import axios from '@axios'
import exportUtils from '@/hooks/exportUtils'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'

export default {
  components: { BFormCheckbox, BFormGroup, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, EnrollmentsListFilters,  VueSelect, BForm, TextInputValidated },
  setup(){
    const { fetchEnrollments, tableColumns, perPage, currentPage, totalEnrollments, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, refEnrollmentListTable, refetchData, studentFilter, courseFilter, groupFilter, studentsOptions, coursesOptions, groupOptions } = useEnrollmentsList()
    const ENROLLMENTS_APP_STORE_MODULE_NAME = 'enrollments'
    const { deletePopup, errorToast, successToast } = popups()
    const { exportData, openDownloadingAlert, closeDownloadingAlert} = exportUtils()
    // Modal 
    const paymentMethods = ref([])
    const cashes = ref([])
    const showCashes=ref(false)
    const renewalModal=ref(null)
    const renewParams=ref({
      month_number:null, 
      enrollment_id:null,
      paid: null, 
      payment_method_id: null,
      cash_id:null, 
    })
  
    provide('studentFilter', studentFilter)
    provide('courseFilter', courseFilter)
    provide('groupFilter', groupFilter)
    provide('students', studentsOptions)
    provide('courses', coursesOptions)
    provide('groups', groupOptions)

    const openRenewalModal=(id) =>  {
      renewParams.value.enrollment_id=id
      renewParams.value.payment_method_id=null
      renewParams.value.cash_id=null
      renewParams.value.month_number=null
      renewParams.value.paid=false
      renewalModal.value.show();
    }

    const renewMonthlyPayment=() => {

      if (!renewParams.value.month_number) {
        return errorToast("Introduce un número de meses")
      }

      if (!renewParams.value.payment_method_id) {
        return errorToast("Introduce un método de pago")
      }

      if ((renewParams.value.payment_method_id==1 && !renewParams.value.cash_id) && renewParams.value.paid===true) {
        return errorToast("Introduce una caja")
      }

      document.getElementById('submitbutton').disabled=true;
      axios.post("renew-monthly-payment", { renewParams: renewParams.value}).then(response => {

        if (response.data.success) {
          renewalModal.value.hide()
          document.getElementById('submitbutton').disabled=false;
          successToast(`Matrícula renovada`)
          // let data = {
          //   idRC: response.data.invoice_id
          // }

          //   if(exportData('/download-ticket', data, response.data.invoice_name, "PDF")) {
          //       successToast(`PDF descargado`)
          //       closeDownloadingAlert()
          //   }else{
          //       errorToast(`No ha sido posible descargar el PDF`)
          //   }  
          refetchData()
        } else {
          document.getElementById('submitbutton').disabled=false;
          errorToast(response.data.msg)
        }
      })
    }


    axios.get('/payment-methods').then(response =>{
            paymentMethods.value = response.data
        })

    axios.get('cashes').then(response => {
      cashes.value=response.data.cashes
    })


    watch(renewParams, () => {
      if (renewParams.value.payment_method_id==1 && renewParams.value.paid) {
          showCashes.value=true
        } else {
          showCashes.value=false
          renewParams.value.cash_id=null
        }
    }, {deep:true})


    if(!store.hasModule(ENROLLMENTS_APP_STORE_MODULE_NAME)){
      store.registerModule(ENROLLMENTS_APP_STORE_MODULE_NAME, enrollmentsStoreModule)
    }

    onUnmounted(() => {
      if(store.hasModule(ENROLLMENTS_APP_STORE_MODULE_NAME)){
        store.unregisterModule(ENROLLMENTS_APP_STORE_MODULE_NAME)
      }
    })

    return {
      format,
      fetchEnrollments,
      tableColumns,
      perPage,
      currentPage,
      totalEnrollments,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refEnrollmentListTable,
      refetchData,
      ability,
      deletePopup,
      paymentMethods,
      renewalModal,
      showCashes,
      openRenewalModal,
      cashes,
      renewParams,
      renewMonthlyPayment,
      groupOptions
    }
  }
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
